import openPopup from "../popup.js";

const firmwareTitle = document.querySelector("#popup-firmware .firmware-title");
const firmwareContent = document.querySelector("#popup-firmware .firmware-content");
let firmwareLink = document.querySelector("#popup-firmware .ui-btn");
const btnOpenFirmwarePopup = document.querySelectorAll(".btn_firmware");

const firmwareBasicLink = "https://iql.finance/firmwares/Whatsminer-m2x-m3x-m5x-28_normal_bixbitsite_AMS_bixbit_site_1.4.8_1psu.bin";
const firmware2PSULink = "https://iql.finance/firmwares/Whatsminer-m2x-m3x-m5x-28_normal_bixbitsite_AMS_bixbit_site_1.4.8_2psu.bin";
const H3plata = "https://iql.finance/firmwares/H3 SD card Program-20210121.zip";
const H6plata = "https://iql.finance/firmwares/H6 SD Card Program-20210121.zip";
const H616plata = "https://iql.finance/firmwares/H616 SD card program-20220729.zip";
const H6osplata = "https://iql.finance/firmwares/H6os SD Card Program-20220422.zip";
const firmwareTool = "https://iql.finance/firmwares/WhatsMinerTool-8.1.38.zip";

const firmwareData = [
    {
        id: 1,
        title: FIRMWARES.firmware1.title,
        file: "https://iql.finance/firmwares/Whatsminer-m2x-m3x-m5x-28_normal_bixbitsite_AMS_bixbit_site_1.4.8_1psu.bin",
        content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">${FIRMWARES.firmware1.description.item1.text}</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">${FIRMWARES.firmware1.description.item2.title}</h5>
               <p class="content-text">${FIRMWARES.firmware1.description.item2.text}</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">${FIRMWARES.firmware1.instruction.title}</h5>

               <div class="important-item">
                  <h6 class="item-title">${FIRMWARES.firmware1.instruction.item1.title}</h6>
                  <p class="content-text">${FIRMWARES.firmware1.instruction.item1.text}</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">${FIRMWARES.firmware1.instruction.item2.text1} <a href=${firmwareBasicLink} target="_blank">${FIRMWARES.firmware1.instruction.item2.textLink}</a>${FIRMWARES.firmware1.instruction.item2.text2}<a href=${firmwareTool} target="_blank">WhatsMinerTool</a>${FIRMWARES.firmware1.instruction.item2.text3}</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">${FIRMWARES.firmware1.instruction.item3.text}</p>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">${FIRMWARES.firmware1.instruction.item4List.li1.text}<strong>H3, H6, H6os</strong>).</li>
                     <li class="content-list-item">${FIRMWARES.firmware1.instruction.item4List.li2.text1}<a href=${H3plata} target="_blank">H3</a>, <a href=${H6plata} target="_blank">H6</a>${FIRMWARES.firmware1.instruction.item4List.li2.text2}<a href=${H6osplata} target="_blank">H6os</a>${FIRMWARES.firmware1.instruction.item4List.li2.text2}</li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware1.instruction.item4List.li3.text}</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/9QC2ueL1E2g?si=z_uc8avthp_sqadI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware1.instruction.item4List.li4.text1}<strong>Configuration>Miner Configuration>Overclock</strong>${FIRMWARES.firmware1.instruction.item4List.li4.text2}</p>
                        <p class="content-text">${FIRMWARES.firmware1.instruction.item4List.li4.text3}<strong>Immersion Cooling</strong>${FIRMWARES.firmware1.instruction.item4List.li4.text4}<strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmwareBasicLink} target="_blank" download>
            <span>${UI_LOCALIZATION.btnDownload}</span> <img src="../../assets/img/icons/download.svg"></i>
         </a>
      `,
    },

    {
        id: 2,
        title: FIRMWARES.firmware2.title,
        file: "https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_1psu.bin",
        content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">${FIRMWARES.firmware2.description.item1.text}</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">${FIRMWARES.firmware2.description.item2.title}</h5>
               <p class="content-text">${FIRMWARES.firmware2.description.item2.text}</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">${FIRMWARES.firmware2.instruction.title}</h5>

               <div class="important-item">
                     <h6 class="item-title">${FIRMWARES.firmware2.instruction.item1.title}</h6>
                     <p class="content-text">${FIRMWARES.firmware2.instruction.item1.text}</p>
               </div>

               <div class="content-wrap">
                     <p class="content-text">${FIRMWARES.firmware2.instruction.item2.text1}<a href=${firmwareBasicLink} target="_blank">${FIRMWARES.firmware2.instruction.item2.textLink}</a>${FIRMWARES.firmware2.instruction.item2.text2}<a href=${firmwareTool} target="_blank">WhatsMinerTool</a>${FIRMWARES.firmware2.instruction.item2.text3}</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">${FIRMWARES.firmware2.instruction.item3.text}</p>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">${FIRMWARES.firmware2.instruction.item4List.li1.text}<strong>H3, H6, H6os, H616</strong>).</li>
                     <li class="content-list-item">${FIRMWARES.firmware2.instruction.item4List.li2.text1}<a href=${H3plata} target="_blank">H3</a>, <a href=${H6plata} target="_blank">H6</a>, <a href=${H6osplata} target="_blank">H6os</a>${FIRMWARES.firmware2.instruction.item4List.li2.text2}<a href=${H616plata} target="_blank">H616</a>${FIRMWARES.firmware2.instruction.item4List.li2.text3}</li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware2.instruction.item4List.li3.text}</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=EaORD8gkUPDce8zE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware2.instruction.item4List.li4.text1}<strong>Configuration>Miner Configuration>Overclock</strong>${FIRMWARES.firmware2.instruction.item4List.li4.text2}</p>
                        <p class="content-text">${FIRMWARES.firmware2.instruction.item4List.li4.text3}<strong>Immersion Cooling</strong>${FIRMWARES.firmware2.instruction.item4List.li4.text4}<strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmwareBasicLink} target="_blank" download>
            <span>${UI_LOCALIZATION.btnDownload}</span> <img src="../../assets/img/icons/download.svg"></i>
         </a>
      `,
    },

    {
        id: 3,
        title: FIRMWARES.firmware3.title,
        file: "https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_1psu.bin",
        content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">${FIRMWARES.firmware3.description.item1.text}</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">${FIRMWARES.firmware3.description.item2.title}</h5>
               <p class="content-text">${FIRMWARES.firmware3.description.item2.text1}</p>
               <p class="content-text">${FIRMWARES.firmware3.description.item2.text2}</p>
               <p class="content-text">${FIRMWARES.firmware3.description.item2.text3}</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">${FIRMWARES.firmware3.instruction.title}</h5>

               <div class="important-item">
                  <h6 class="item-title">${FIRMWARES.firmware3.instruction.item1.title}</h6>
                  <p class="content-text">${FIRMWARES.firmware3.instruction.item1.text}</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">${FIRMWARES.firmware3.instruction.item2.text1}<a href=${firmwareBasicLink} target="_blank"${FIRMWARES.firmware3.instruction.item2.textLink}</a>${FIRMWARES.firmware3.instruction.item2.text2}<a href=${firmwareTool} target="_blank">WhatsMinerTool</a>${FIRMWARES.firmware3.instruction.item2.text3}</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">${FIRMWARES.firmware3.instruction.item3.text}</p>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">${FIRMWARES.firmware3.instruction.item4List.li1.text}<strong>H6os, H616</strong>).</li>
                     <li class="content-list-item">${FIRMWARES.firmware3.instruction.item4List.li2.text1}<a href=${H6osplata} target="_blank">H6os</a>${FIRMWARES.firmware3.instruction.item4List.li2.text2}<a href=${H616plata} target="_blank">H616</a>${FIRMWARES.firmware3.instruction.item4List.li2.text3}</li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware3.instruction.item4List.li3.text}</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware3.instruction.item4List.li4.text1}<strong>Configuration>Miner Configuration>Overclock</strong>${FIRMWARES.firmware3.instruction.item4List.li4.text2}</p>
                        <p class="content-text">${FIRMWARES.firmware3.instruction.item4List.li4.text3}<strong>Immersion Cooling</strong>${FIRMWARES.firmware3.instruction.item4List.li4.text4}<strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmwareBasicLink} target="_blank" download>
            <span>${UI_LOCALIZATION.btnDownload}</span> <img src="../../assets/img/icons/download.svg"></i>
         </a>
      `,
    },

    {
        id: 4,
        title: FIRMWARES.firmware4.title,
        file: "https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_2psu.bin",
        content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">${FIRMWARES.firmware4.description.item1.text}</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">${FIRMWARES.firmware4.description.item2.title}</h5>
               <p class="content-text">${FIRMWARES.firmware4.description.item2.text1}</p>
               <p class="content-text">${FIRMWARES.firmware4.description.item2.text2}</p>
               <p class="content-text">${FIRMWARES.firmware4.description.item2.text3}</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">${FIRMWARES.firmware4.instruction.title}</h5>

               <div class="important-item">
                  <h6 class="item-title">${FIRMWARES.firmware4.instruction.item1.title}</h6>
                  <p class="content-text">${FIRMWARES.firmware4.instruction.item1.text}</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">${FIRMWARES.firmware4.instruction.item2.text1}<a href=${firmware2PSULink} target="_blank">${FIRMWARES.firmware4.instruction.item2.textLink}</a>${FIRMWARES.firmware4.instruction.item2.text2}<a href=${firmwareTool} target="_blank">WhatsMinerTool</a>${FIRMWARES.firmware4.instruction.item2.text3}</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">${FIRMWARES.firmware4.instruction.item2.text3}</p>
                  <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=LcVkHBfwpsfZ4CLd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware4.instruction.item4List.li1.text}</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware4.instruction.item4List.li2.text1}<strong>Configuration>Miner Configuration>Overclock</strong>${FIRMWARES.firmware4.instruction.item4List.li2.text2}</p>
                        <p class="content-text">${FIRMWARES.firmware4.instruction.item4List.li2.text2}<strong>Immersion Cooling</strong>${FIRMWARES.firmware4.instruction.item4List.li2.text4}<strong>Configuration>Miner Configuration>PSU Firmware>Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmware2PSULink} target="_blank" download>
            <span>${UI_LOCALIZATION.btnDownload}</span> <img src="../../assets/img/icons/download.svg"></i>
         </a>
      `,
    },

    {
        id: 5,
        title: FIRMWARES.firmware5.title,
        file: "https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_2psu.bin",
        content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">${FIRMWARES.firmware5.description.item1.text}</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">${FIRMWARES.firmware5.description.item2.title}</h5>
               <p class="content-text">${FIRMWARES.firmware5.description.item2.text1}</p>
               <p class="content-text">${FIRMWARES.firmware5.description.item2.text2}</p>
               <p class="content-text">${FIRMWARES.firmware5.description.item2.text3}</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">${FIRMWARES.firmware5.instruction.title}</h5>

               <div class="important-item">
                  <h6 class="item-title">${FIRMWARES.firmware5.instruction.item1.title}</h6>
                  <p class="content-text">${FIRMWARES.firmware5.instruction.item1.text}</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">${FIRMWARES.firmware5.instruction.item2.text1}<a href=${firmware2PSULink} target="_blank">${FIRMWARES.firmware5.instruction.item2.textLink}</a>${FIRMWARES.firmware5.instruction.item2.text2}<a href=${firmwareTool} target="_blank">WhatsMinerTool</a>${FIRMWARES.firmware5.instruction.item2.text3}</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">${FIRMWARES.firmware5.instruction.item3.text}</p>
                  <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=LcVkHBfwpsfZ4CLd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware5.instruction.item4List.li1.text}</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware5.instruction.item4List.li2.text1}<strong>Configuration &gt; Miner Configuration &gt; Overclock</strong>${FIRMWARES.firmware5.instruction.item4List.li2.text2}</p>
                        <p class="content-text">${FIRMWARES.firmware5.instruction.item4List.li2.text3}<strong>Immersion Cooling</strong>${FIRMWARES.firmware5.instruction.item4List.li2.text4}<strong>Configuration &gt; Miner Configuration &gt; PSU Firmware &gt; Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmware2PSULink} target="_blank" download>
            <span>${UI_LOCALIZATION.btnDownload}</span> <img src="../../assets/img/icons/download.svg"></i>
         </a>
      `,
    },

    {
        id: 6,
        title: FIRMWARES.firmware6.title,
        file: "https://iql.finance/Whatsminer-m2x-m3x-m5x-_normal__AMS_149.1763_1.4.7_2psu.bin",
        content: `
         <div class="description">
            <div class="content-item">
               <p class="content-text">${FIRMWARES.firmware6.description.item1.text}</p>
            </div>

            <div class="content-item">
               <h5 class="content-subtitle">${FIRMWARES.firmware6.description.item2.title}</h5>
               <p class="content-text">${FIRMWARES.firmware6.description.item2.text1}</p>
               <p class="content-text">${FIRMWARES.firmware6.description.item2.text2}</p>
               <p class="content-text">${FIRMWARES.firmware6.description.item2.text3}</p>
            </div>
         </div>

         <div class="instruction">
            <div class="content-wrap">
               <h5 class="content-title">${FIRMWARES.firmware6.instruction.title}</h5>

               <div class="important-item">
                  <h6 class="item-title">${FIRMWARES.firmware6.instruction.item1.title}</h6>
                  <p class="content-text">${FIRMWARES.firmware6.instruction.item1.text}</p>
               </div>

               <div class="content-wrap">
                  <p class="content-text">${FIRMWARES.firmware6.instruction.item2.text1}<a href=${firmware2PSULink} target="_blank">${FIRMWARES.firmware6.instruction.item2.textLink}</a>${FIRMWARES.firmware6.instruction.item2.text2}<a href=${firmwareTool} target="_blank">WhatsMinerTool</a>${FIRMWARES.firmware6.instruction.item2.text3}</p>
               </div>

               <div class="content-item">
                  <p class="content-text text_subtitle">${FIRMWARES.firmware6.instruction.item3.text}</p>
                  <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=LcVkHBfwpsfZ4CLd" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
               </div>

               <div class="content-item">
                  <ul class="content-list">
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware6.instruction.item4List.li1.text}</p>
                        <iframe loading="lazy" src="https://www.youtube.com/embed/KfV9eOSeqMw?si=FMT5BR8FVeTWrx41" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                     </li>
                     <li class="content-list-item">
                        <p class="content-text">${FIRMWARES.firmware6.instruction.item4List.li2.text1}<strong>Configuration &gt; Miner Configuration &gt; Overclock</strong>${FIRMWARES.firmware6.instruction.item4List.li2.text2}</p>
                        <p class="content-text">${FIRMWARES.firmware6.instruction.item4List.li2.text3}<strong>Immersion Cooling</strong>${FIRMWARES.firmware6.instruction.item4List.li2.text4}<strong>Configuration &gt; Miner Configuration &gt; PSU Firmware &gt; Upgrade PSU Firmware.</strong></p>
                     </li>
                  </ul>
               </div>
            </div>
         </div>

         <a class="ui-btn colorful" href=${firmware2PSULink} target="_blank" download>
            <span>${UI_LOCALIZATION.btnDownload}</span> <img src="../../assets/img/icons/download.svg"></i>
         </a>
      `,
    },
];

btnOpenFirmwarePopup.forEach(item => {
    item.addEventListener("click", function () {
        let currentBtn = this.getAttribute("data-id");
        firmwareTitle.innerHTML = "";
        firmwareContent.innerHTML = "";

        let currentDataFirmware = firmwareData.find(item => item.id == currentBtn);

        if (currentDataFirmware) {
            let { title, content, file } = currentDataFirmware;

            firmwareTitle.insertAdjacentHTML("afterbegin", title);
            firmwareContent.insertAdjacentHTML("afterbegin", content);
        }
    });
});

new openPopup({
    selector: "#popup-firmware",
    elOpen: ".btn_firmware",
    elClose: "#popup-firmware .ui-close",
    overlay: "#popup-firmware .popup-overlay",
    hasVideo: true,
});
